import { HttpEventType } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import * as FileSaver from "file-saver";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import mimeTypes from "../../../../utils/mime-types";
import { PolizaModal } from "../modal-poliza/modal-poliza.component";
import { PolizaService } from "../polizas.service";

@Component({
  selector: "app-form-polizas",
  templateUrl: "./form.component.html",
})
export class PolizaForm implements OnInit {
  @ViewChild("table", { static: false })
  public tableComp: CardTableComponent;
  public columns: ListColumn[] = [
    {
      name: "Vigencia",
      property: "Vigencia",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: any[] = [
    {
      desc: "Descargar",
      action: "down",
      visible: (row) => true,
    },
  ];

  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  public empresa: any[] = [];
  public tipos: any[] = [];
  public estatus: any[] = [
    { Id: "A", Desc: "Funcional" },
    { Id: "M", Desc: "Mantenimiento" },
    { Id: "Y", Desc: "Yarda" },
  ];
  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();

  constructor(
    private service: PolizaService,
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private alerts: AlertasSwalService
  ) {}

  public ngOnInit() {}

  loadPolizas() {
    this.service.getPolizas(this.defaults.IdUnidad).subscribe(
      (resultData) => {
        this.tableComp.setData(resultData);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
  }
  public setUpdate(row: any) {
    this.mode = "update";
    this.changeDetectorRef.detectChanges();
    this.defaults = row;
    this.loadPolizas();
  }

  actionstable(e: { action: string; row: any }) {
    this.service.down(e.row.IdUnidadPoliza).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        const exist = mimeTypes[contentType];
        this.downLoadFile(response.body, contentType, "poliza");
      },
      (err) => {
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }

  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
  }
  async openDialog() {
    const result = await this.dialog
      .open(PolizaModal, { panelClass: ["w-full", "lg:w-1/2"] })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service
        .add(
          { IdUnidad: this.defaults.IdUnidad, Vigencia: result.Vigencia },
          result.poliza
        )
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.Response) {
              if (event.ok) {
                this.alerts.correcta("Correcto", "Poliza guardada");
                this.loadPolizas();
              } else {
                this.alerts.error("Error", "Ocurrio un error");
              }
            }
          },
          (err) => {
            this.alerts.error("Error", "Ocurrio un error");
          }
        );
    }
  }
}
